<template>
  <div class="shopping-cart" id="shoppingCart">
    <p class="desc">购物车</p>
    <div class="filter-commodity-condition">
      <el-input class="gray" v-model="searchKey" placeholder="商品名称"></el-input>
      <div class="btn-container">
        <el-button class="btn-red" @click="filterCommodity">筛选</el-button>
      </div>
    </div>
    <!-- 购物车表格 -->
    <div class="table-shopping-cart">
      <div class="title-shopping-cart">
        <span v-for="(item, index) in tableTitle" :key="index">
          {{ item.name }}
        </span>
      </div>
      <div v-show="commodityList.length > 0" class="content-shopping-cart" v-for="(i, index) in commodityList" :key="index">
        <div class="setMeal-content" v-if="i.setMealId">
          <div class="setMeal-top">
            <div class="goods-shopping-cart">
              <div class="selet-shopping-cart">
                <div class="select-container" v-show="i.status">
                  <el-checkbox
                    v-model="i.isSelected"
                    :disabled="i.amount>i.reserve"
                  ></el-checkbox>
                </div>
                <div class="desc-container" v-show="!i.status">
                  <span class="invalid-desc">失效</span>
                </div>
              </div>
              <div class="setMeal-tags">
                套餐
              </div>
              <p :class="i.status?'setMeal-title':'active'" class="setMeal-title" :title="i.title">{{ i.title }}</p>
            </div>
            <div class="specs-shopping-cart"></div>
            <div class="unitPrice-shopping-cart"></div>
            <div class="nums-shopping-cart" v-if="i.status">
              <el-input-number
                v-model="i.amount"
                @change="handleAmountChange(i,index)"
                :min="1"
              ></el-input-number>
            </div>
            <div class="nums-shopping-cart" v-else>
              <span class="active">已失效</span>
            </div>
            <div class="subtotal-shopping-cart">
              <span v-show="i.status">￥{{i.subtotal}}</span>
              <span class="active" v-show="!i.status">已失效</span>
            </div>
            <div class="operation-shopping-cart">
              <div class="btns">
                <span class="delete-btn" @click="deleteCommodity(i)">删除</span>
              </div>
            </div>
          </div>
          <div class="setMeal-children" v-for="(val, ind) in i.setMealGoodsList" :key="ind">
            <div class="goods-shopping-cart">
              <div class="img-desc-container">
                <div class="img-container">
                  <img
                    v-if="val.img"
                    class="commodity-img"
                    :src="val.img"
                    alt="商品图"
                    @click="goToProduct(val.goodsId)"
                  />
                  <img
                    v-else
                    class="commodity-img"
                    src="http://image.8844it.com/ydb2/goodDefault.png"
                    alt="商品图"
                    @click="goToProduct(val.goodsId)"
                  />
                </div>
                <div>
                  <p
                    class="commodity-desc"
                    :class="i.status?'commodity-desc':'active'"
                    :title="val.name"
                    @click="goToProduct(val.goodsId)"
                  >{{val.name}}</p>
                </div>
              </div>
            </div>
            <div class="specs-shopping-cart">
              <span v-show="i.status">{{ val.norm }}</span>
              <span class="active" v-show="!i.status">已失效</span>
            </div>
            <div class="unitPrice-shopping-cart">
              <span v-show="i.status">￥{{val.price}}</span>
              <span class="active" v-show="!i.status">已失效</span>
            </div>
            <div class="nums-shopping-cart">
              <span v-show="i.status">x{{ val.amount }}</span>
              <span class="active" v-show="!i.status">已失效</span>
            </div>
            <div class="subtotal-shopping-cart">
              <span v-show="i.status">￥{{val.price}}</span>
              <span class="active" v-show="!i.status">已失效</span>
            </div>
            <div class="operation-shopping-cart"></div>
          </div>
        </div>
        <div class="item-goods" v-else>
          <div class="goods-shopping-cart">
            <div class="selet-shopping-cart">
              <div class="select-container" v-show="i.status">
                <el-checkbox
                  v-model="i.isSelected"
                  :disabled="i.amount>i.reserve"
                ></el-checkbox>
              </div>
              <div class="desc-container" v-show="!i.status">
                <span class="invalid-desc">失效</span>
              </div>
            </div>
            <div class="img-desc-container">
              <div class="img-container">
                <img
                  v-if="i.img"
                  class="commodity-img"
                  :src="i.img"
                  alt="商品图"
                  @click="goToProduct(i.goodsId)"
                />
                <img
                  v-else
                  class="commodity-img"
                  src="http://image.8844it.com/ydb2/goodDefault.png"
                  alt="商品图"
                  @click="goToProduct(i.goodsId)"
                />
              </div>
              <div>
                <p
                  class="commodity-desc"
                  :class="i.status?'commodity-desc':'active'"
                  :title="i.desc"
                  @click="goToProduct(i.goodsId)"
                >{{i.desc}}</p>
                <p class="buyLimit" v-if="i.buyLimit>0">(限购{{i.buyLimit}}件)</p>
              </div>
            </div>
          </div>
          <div class="specs-shopping-cart">
            <span v-show="i.status">{{i.norm}}</span>
            <span class="active" v-show="!i.status">已失效</span>
          </div>
          <div class="unitPrice-shopping-cart">
            <span v-show="i.status">￥{{i.unitPrice}}</span>
            <span class="active" v-show="!i.status">已失效</span>
          </div>
          <div class="nums-shopping-cart" v-if="i.status">
            <el-input-number
              v-if="i.reserve>=i.amount"
              v-model="i.amount"
              @change="handleAmountChange(i,index)"
              :min="1"
              :max="i.reserve"
            ></el-input-number>
            <el-input-number
              v-else
              v-model="i.amount"
              @change="handleAmountChange(i,index)"
              :min="1"
            ></el-input-number>
          </div>
          <div class="nums-shopping-cart" v-else>
            <span class="active">已失效</span>
          </div>
          <div class="subtotal-shopping-cart">
            <span v-show="i.status">￥{{i.subtotal}}</span>
            <span class="active" v-show="!i.status">已失效</span>
          </div>
          <div class="operation-shopping-cart">
            <div class="btns">
              <span class="delete-btn" @click="deleteCommodity(i)">删除</span>
              <span
                v-show="i.status"
                class="remove-btn"
                @click="collectCommodity(i.id)"
              >移到我的收藏</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-shopping-cart" v-if="commodityList.length === 0">
        <div class="nothing">
          暂无数据
        </div>
      </div>
    </div>




    <!-- <el-table class="table-container" ref="shoppingCartTable" :data="commodityList">
      <el-table-column label width="60">
        <template slot-scope="props">
          <div class="select-container" v-show="props.row.status">
            <el-checkbox
              v-model="props.row.isSelected"
              :disabled="props.row.amount>props.row.reserve"
            ></el-checkbox>
          </div>
          <div class="desc-container" v-show="!props.row.status">
            <span class="invalid-desc">失效</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商品" width="240" align="center">
        <template slot-scope="props">
          <div class="img-desc-container">
            <div class="img-container">
              <img
                v-if="props.row.img"
                class="commodity-img"
                :src="props.row.img"
                alt="商品图"
                @click="goToProduct(props.row.goodsId)"
              />
              <img
                v-else
                class="commodity-img"
                src="http://image.8844it.com/ydb2/goodDefault.png"
                alt="商品图"
                @click="goToProduct(props.row.goodsId)"
              />
            </div>
            <div>
              <p
                class="commodity-desc"
                :class="props.row.status?'commodity-desc':'active'"
                :title="props.row.desc"
                @click="goToProduct(props.row.goodsId)"
              >{{props.row.desc}}</p>
              <p class="buyLimit" v-if="props.row.buyLimit>0">(限购{{props.row.buyLimit}}件)</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="规格" prop="norm" align="center">
        <template slot-scope="props">
          <span v-show="props.row.status">{{props.row.norm}}</span>
          <span class="active" v-show="!props.row.status">已失效</span>
        </template>
      </el-table-column>
      <el-table-column label="单价" align="center">
        <template slot-scope="props">
          <span v-show="props.row.status">￥{{props.row.unitPrice}}</span>
          <span class="active" v-show="!props.row.status">已失效</span>
        </template>
      </el-table-column>
      <el-table-column label="数量" align="center">
        <template slot-scope="props" v-if="props.row.status">
          <el-input-number
            v-if="props.row.reserve>=props.row.amount"
            v-model="props.row.amount"
            @change="handleAmountChange(props.row,props.$index)"
            :min="1"
            :max="props.row.reserve"
          ></el-input-number>
          <el-input-number
            v-else
            v-model="props.row.amount"
            @change="handleAmountChange(props.row,props.$index)"
            :min="1"
          ></el-input-number>
        </template> -->
        <!-- <template slot-scope="props" v-else>
          <el-input-number disabled v-model="props.row.amount"></el-input-number>
        </template> -->
        <!-- <template slot-scope="props" v-else>
          <span class="active">已失效</span>
        </template>
      </el-table-column>
      <el-table-column label="小计" align="center">
        <template slot-scope="props">
          <span v-show="props.row.status">￥{{props.row.subtotal}}</span>
          <span class="active" v-show="!props.row.status">已失效</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="props">
          <div class="btns">
            <span class="delete-btn" @click="deleteCommodity(props.row)">删除</span>
            <span
              v-show="props.row.status"
              class="remove-btn"
              @click="collectCommodity(props.row.id)"
            >移到我的收藏</span>
          </div>
        </template>
      </el-table-column>
    </el-table> -->
    <div class="shopping-cart-operation" ref="shoppingCartOperation">
      <div class="left">
        <el-checkbox @change="toggleCommodityStatus" v-model="isSelectedAllCommodity">全选</el-checkbox>
        <div class="btn delete-selected-btn" @click="deleteSelectedCommodity">删除选中的商品</div>
        <div class="btn remove-selected-btn" @click="addCommodityToCollection">移到我的收藏</div>
        <div class="btn clear-btn" @click="clearShoppingCart">清空购物车</div>
      </div>
      <div class="right">
        <div class="desc-amount">
          已选择
          <span class="amount">{{selectedCommodityAmount}}</span>
          件商品
        </div>
        <div class="desc-total">
          <p>
            总价：
            <span class="total">￥{{totalPrice}}</span>
          </p>
          <p>
            促销：
            <span class="total">￥{{promationPrice}}</span>
          </p>
        </div>
        <el-button class="settle-btn" @click="toSettle">去结算</el-button>
      </div>
    </div>
    <div
      class="shopping-cart-operation fixed"
      :class="showFixedOperation ? '' : 'hide-operation'"
      ref="fixedOperstion"
    >
      <div class="left">
        <el-checkbox @change="toggleCommodityStatus" v-model="isSelectedAllCommodity">全选</el-checkbox>
        <div class="btn delete-selected-btn" @click="deleteSelectedCommodity">删除选中的商品</div>
        <div class="btn remove-selected-btn" @click="addCommodityToCollection">移到我的收藏</div>
        <div class="btn clear-btn" @click="clearShoppingCart">清空购物车</div>
      </div>
      <div class="right">
        <div class="desc-amount">
          已选择
          <span class="amount">{{selectedCommodityAmount}}</span>
          件商品
        </div>
        <div class="desc-total">
          <p>
            总价：
            <span class="total">￥{{totalPrice}}</span>
          </p>
          <p>
            促销：
            <span class="total">￥{{promationPrice}}</span>
          </p>
        </div>
        <el-button class="settle-btn" @click="toSettle">去结算</el-button>
      </div>
    </div>
    <!-- 操作弹框 -->
    <Dialog
      :dialogType="dialogType"
      :title="dialogTitle"
      :content="dialogContent"
      :dialogVisible="showDialog"
      @confirm="onConfirm"
      @cancel="onCancel"
      @hide="hideDialog"
    ></Dialog>
  </div>
</template>

<script>
import Dialog from "base/xb-base/Dialog";
import ShoppingCart from "models/xb/shopping-cart.js";
const shoppingCart = new ShoppingCart();
const dialogTypes = {
  alertDialog: "alert",
  confrimDialog: "confirm"
};
const alertDialogType = 1;
const confirmDialogTypes = {
  // 删除购物车商品
  delete: 2,
  // 移到我的收藏
  remove: 3,
  // 清空购物车
  clear: 4
};
export default {
  data() {
    return {
      // 是否展示购物车吸底操作按钮
      showFixedOperation: false,
      searchKey: "",
      tableTitle: [
        {name: '商品'},
        {name: '规格'},
        {name: '单价'},
        {name: '数量'},
        {name: '小计'},
        {name: '操作'},
      ],
      commodityList: [],
      // 勾选的商品列表
      selectedShopCartIds: [],
      // 商品是否全部选中
      isSelectedAllCommodity: false,
      // 弹窗值设置
      dialogType: "confirm",
      dialogTitle: "操作提示",
      dialogContent: "",
      showDialog: false,
      // 当前 dialog 类型
      currDialogType: 0,
      totalPrice: 0, // 总价
      promationPrice: 0 // 促销价
    };
  },
  computed: {
    // 有效商品
    effectiveCommodityList() {
      return this.commodityList.filter(item => !item.setMealId?(item.status&&(item.amount<=item.reserve)):item.status);
    },
    // 勾选的商品总个数
    selectedCommodityAmount() {
      let amountTotal = 0;
      this.selectedShopCartIds.map(item => {
        amountTotal += item.amount;
      });
      return amountTotal;
    }
    // 勾选商品的订单总价
    // selectedCommodityTotal() {
    //   let total = 0;
    //   this.selectedShopCartIds.map(item => {
    //     total += item.subtotal;
    //   });
    //   return total;
    // }
  },
  watch: {
    commodityList: {
      deep: true,
      handler(newVal, oldVal) {
        newVal.map(item => {
          // 商品数量变化，小计要更新
          item.subtotal = Number(item.unitPrice) * Number(item.amount);
          // 更新被选中的商品列表
          let isHave = this.selectedShopCartIds.find(
            selectedItem => (selectedItem.setMealId?selectedItem.setMealId:selectedItem.skuId) === (item.setMealId?item.setMealId:item.skuId)
          );
          if (item.isSelected) {
            if (!isHave) {
              this.selectedShopCartIds.push(item);
            }
          } else {
            if (isHave) {
              // 剔除
              let index = this.selectedShopCartIds.findIndex(
                selectedItem => (selectedItem.setMealId?selectedItem.setMealId:selectedItem.skuId) === (item.setMealId?item.setMealId:item.skuId)
              );
              this.selectedShopCartIds.splice(index, 1);
            }
          }
          if (this.effectiveCommodityList.length > 0) {
            this.isSelectedAllCommodity =
              this.effectiveCommodityList.length ===
              this.selectedShopCartIds.length;
          } else {
            this.isSelectedAllCommodity = false;
          }
        });
      }
    },
    selectedShopCartIds: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.getCartTotalPrice(newVal);
        } else {
          this.totalPrice = 0;
          this.promationPrice = 0;
        }
      }
    }
  },
  methods: {
    toggleCommodityStatus(status) {
      if (status) {
        this._resetCommodityToSelected();
      } else {
        this._resetCommodityToUnselected();
      }
    },
    // 筛选购物车商品
    filterCommodity() {
      let options = {
        searchValue: this.searchKey
      };
      this._getShoppingCartCommodityList(options);
    },
    // 去结算即确认订单
    toSettle() {
      if (!this.selectedShopCartIds.length) {
        this.dialogContent = "请先勾选需结算的商品！";
        this.showDialog = true;
        this.dialogType = dialogTypes.alertDialog;
        this.currDialogType = alertDialogType;
        return false;
      }
      let data = [];
      this.selectedShopCartIds.map(item => {
        data.push(item.id);
      });

      let datas = {
        idShoppingCartList: data
      };
      shoppingCart.confirmOrder(datas).then(res => {
        if (res.success) {
          this.$router.push({
            path: "/confirm-order",
            query: {
              selectedShopCartIds: JSON.stringify(data)
            }
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onConfirm() {
      switch (this.currDialogType) {
        // alert 点确定就是隐藏弹框
        case alertDialogType:
          this.showDialog = false;
          break;
        case confirmDialogTypes.clear:
          // 清空购物车
          this._clearShoppingCart();
          break;
        default:
          break;
      }
    },
    onCancel() {
      this.showDialog = false;
    },
    hideDialog() {
      this.showDialog = false;
    },
    _resetCommodityToSelected() {
      this.effectiveCommodityList.map(item => {
        item.isSelected = true;
      });
    },
    _resetCommodityToUnselected() {
      this.effectiveCommodityList.map(item => {
        item.isSelected = false;
      });
    },
    // 删除所选的商品
    deleteSelectedCommodity() {
      if (!this.selectedShopCartIds.length) {
        this.dialogContent = "请先勾选需删除的商品！";
        this.showDialog = true;
        this.dialogType = dialogTypes.alertDialog;
        this.currDialogType = alertDialogType;
        return false;
      }
      // 先遍历选中的商品
      let data = [];
      // 选中的购物车数据
      this.selectedShopCartIds.map(item => {
        data.push(item.id);
      });
      this._deleteSelectedCommodity(data);
    },
    _deleteSelectedCommodity(data) {
      shoppingCart
        .deleteSelectedCommodity(data)
        .then(res => {
          if (res.success) {
            this.$message({
              message: "删除成功",
              center: true,
              type: "success",
              duration: 1000
            });
            // 重新加载购物车数据
            this._getShoppingCartCommodityList();
            // 将选中的数组置空
            this.selectedShopCartIds = [];
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000
            });
          }
        })
        .catch(e => {
          console.log("删除异常", e);
        });
    },
    // 获取购物车总价
    getCartTotalPrice(value) {
      let data = [];
      value.map(item => {
        data.push(item.id);
      });
      if (data.length > 0) {
        shoppingCart.totalPrice(data).then(res => {
          if (res.success) {
            this.totalPrice = res.result.totalPrice;
            this.promationPrice = res.result.totalPromotionReduce;
          }
        });
      }
    },
    // 移动所选商品至我的收藏
    addCommodityToCollection() {
      if (!this.selectedShopCartIds.length) {
        this.dialogContent = "请先勾选需收藏的商品！";
        this.showDialog = true;
        this.dialogType = dialogTypes.alertDialog;
        this.currDialogType = alertDialogType;
        return false;
      }
      let isSetMeal = false
      let data = [];
      this.selectedShopCartIds.map(item => {
        if (item.setMealId) {
          isSetMeal = true
        }
        data.push(item.id);
      });
      if (isSetMeal) {
        return this.$message.error('套餐暂不支持移动至收藏夹')
      }
      this._addCommodityToCollection(data);
    },
    _addCommodityToCollection(data) {
      shoppingCart
        .addCommodityToCollection(data)
        .then(res => {
          if (res.success) {
            console.log("添加成功", res.result);
            this._getShoppingCartCommodityList();
          } else {
            console.log("添加失败--", res.message);
          }
        })
        .catch(e => {
          console.log("添加异常", e);
        });
    },
    // 清空购物车
    clearShoppingCart() {
      if (!this.commodityList.length) {
        return false;
      }
      this.dialogContent = "即将清空购物车，是否继续操作？";
      this.showDialog = true;
      this.dialogType = dialogTypes.confrimDialog;
      this.currDialogType = confirmDialogTypes.clear;
    },
    _clearShoppingCart() {
      shoppingCart
        .clearShoppingCart()
        .then(res => {
          if (res.success) {
            this.$message({
              message: "操作成功",
              center: true,
              type: "success",
              duration: 1000
            });
            this.commodityList = [];
            this.showDialog = false;
          } else {
            this.$message({
              message: "res.message",
              center: true,
              type: "error",
              duration: 1000
            });
          }
        })
        .catch(e => {
          console.log("清空异常", e);
        });
    },
    // 购物车商品价格数量变化时
    handleAmountChange(commodity, index) {
      let data;
      if (commodity.setMealId) {
        data = {
          id: commodity.id,
          setMealId: commodity.setMealId,
          quantity: commodity.amount
        };
      } else {
        if (commodity.reserve > commodity.amount) {
          data = {
            id: commodity.id,
            itemId: commodity.skuId,
            quantity: commodity.amount
          };
        } else {
          this.commodityList[index].amount = commodity.reserve;
          data = {
            id: commodity.id,
            itemId: commodity.skuId,
            quantity: commodity.reserve
          };
        }
      }
      this._updateCommodityNum(data);
    },
    // 删除某一行商品
    deleteCommodity(commodity) {
      let data = [];
      data.push(commodity.id);
      this._deleteSelectedCommodity(data);
    },
    // 移动某一行商品到收藏
    collectCommodity(id) {
      let data = [];
      data.push(id);
      this._collectCommodity(data);
    },
    // 服务器收藏
    _collectCommodity(data) {
      shoppingCart.addCommodityToCollection(data).then(res => {
        if (res.success) {
          this.$message({
            message: "收藏成功",
            center: true,
            type: "success",
            duration: 1000
          });
          // 重新获取购物车数据
          this._getShoppingCartCommodityList();
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000
          });
        }
      });
    },
    // 计算某个html元素相对于body元素的距离
    _getEleToBodyOffset(htmlEle) {
      let left = 0;
      let top = 0;
      while (htmlEle) {
        left += htmlEle.offsetLeft + htmlEle.clientLeft;
        top += htmlEle.offsetTop + htmlEle.clientTop;
        htmlEle = htmlEle.offsetParent;
      }
      return {
        left,
        top
      };
    },
    // 修改购车商品数量
    _updateCommodityNum(data) {
      shoppingCart
        .updateCommodityNum(data)
        .then(res => {
          if (res.success) {
            console.log("更新成功--", res.result);
            let value = this.selectedShopCartIds;
            this.getCartTotalPrice(value);
          } else {
            console.log("更新失败--", res.message);
          }
        })
        .catch(e => {
          console.log("更新异常--", e);
        });
    },
    // 获取购物车商品列表
    _getShoppingCartCommodityList(options) {
      shoppingCart
        .getShoppingCartCommodityList(options)
        .then(res => {
          if (res.success) {
            console.log("获取购物车列表成功--", res.result);
            this.commodityList = [];
            res.result.map(item => {
              if (!item.setMealId) {
                let normList = JSON.parse(item.title ? item.title : "{}");
                let desc = item.goodsName;
                let norm = "";
                for (let key in normList) {
                  norm += `,${normList[key]}`;
                }
                let buyLimit;
                let reserve;
                if (item.inPromotion) {
                  buyLimit = item.buyLimit;
                  reserve = item.spareBuyLimit
                    ? item.spareBuyLimit > item.saleNum
                      ? item.saleNum
                      : item.spareBuyLimit
                    : item.saleNum;
                } else {
                  buyLimit = 0;
                  reserve = item.saleNum;
                }
                this.commodityList.push({
                  // 记录id
                  id: item.id,
                  goodsId: item.goodsId,
                  skuId: item.itemId,
                  status: item.goodsStatus,
                  isSelected: false,
                  img: item.goodsPic,
                  desc: desc,
                  norm: norm.substring(1),
                  unitPrice: item.price,
                  amount: item.quantity,
                  buyLimit: buyLimit,
                  // 库存
                  reserve: reserve,
                  subtotal: Number(item.price) * Number(item.quantity)
                });
              } else {
                let arr = []
                item.setMealGoodsList.map(val => {
                  let obj = {}
                  obj.skuId = val.itemId
                  obj.goodsId = val.goodsId
                  obj.setMealId = val.setMealId
                  obj.img = val.goodsPic
                  obj.name = val.goodsName
                  obj.price = val.marketPrice
                  obj.amount = val.quantity
                  let normMap = JSON.parse(val.itemTitle) ? JSON.parse(val.itemTitle) : "{}"
                  let norm = "";
                  for (let key in normMap) {
                    norm += `，${normMap[key]}`;
                  }
                  obj.norm = norm.substring(1)
                  arr.push(obj)
                })
                this.commodityList.push({
                  // 记录id
                  id: item.id,
                  goodsId: item.goodsId,
                  setMealId: item.setMealId,
                  status: item.goodsStatus,
                  isSelected: false,
                  unitPrice: item.price,
                  title: item.title,
                  oldPrice: item.oldPrice,
                  amount: item.quantity,
                  setMealGoodsList: arr,
                  subtotal: Number(item.price) * Number(item.quantity)
                });
              }
            });
          } else {
            console.log("获取购物车列表失败--", res.message);
          }
        })
        .catch(e => {
          console.log("获取购物车列表异常--", e);
        });
    },
    // 前往商品详情页
    goToProduct(id) {
      let routeUrl = this.$router.resolve({
        path: "/product",
        query: {
          id: id
        }
      });
      window.open(routeUrl.href, "_blank");
    }
  },
  created() {
    this._getShoppingCartCommodityList();
  },
  mounted() {
    this.$nextTick(() => {
      let offsetPostion = this._getEleToBodyOffset(
        this.$refs.shoppingCartOperation
      );
      this.distance = offsetPostion.top - window.innerHeight;
    });
    window.addEventListener("scroll", e => {
      if (this.distance > 0) {
        if (document.documentElement.scrollTop < this.distance) {
          // 展示吸底的购物车操作按钮
          this.showFixedOperation = true;
        } else {
          // 隐藏吸底的购物车操作按钮
          this.showFixedOperation = false;
        }
      }
    });
  },
  components: {
    Dialog
  }
};
</script>

<style lang="scss" scoped>
.shopping-cart {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  font-size: 16px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: #606266;
  padding: 0 20px 20px 20px;
  .desc {
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(96, 98, 102, 1);
    border-bottom: 1px solid #e4e4e4;
  }
  .filter-commodity-condition {
    height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    margin-bottom: 16px;
    .gray {
      width: 220px;
      margin-right: 28px;
    }
    .btn-container {
      width: 80px;
      .btn-red {
        height: 32px;
        width: 80px;
        color: #fff;
        background: rgba(223, 52, 69, 0.75);
        &:active {
          border: none;
        }
        &:hover {
          background: rgba(223, 52, 69, 1);
        }
      }
    }
  }
  .table-container {
    border: 1px solid #e4e4e4;
    font-size: 12px;
    .desc-container {
      border: 1px solid red;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      .invalid-desc {
        font-size: 12px;
        color: #e83632;
      }
    }
    .active {
      color: #bebebe;
    }
    .img-desc-container {
      display: flex;
      align-items: center;
      .img-container {
        .commodity-img {
          width: 56px;
          height: 56px;
          cursor: pointer;
        }
      }
      .commodity-desc {
        height: 40px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        cursor: pointer;
        text-align: left;
      }
      .commodity-desc:hover {
        color: #df3445;
      }
      .buyLimit {
        color: #df3445;
      }
    }
    .img-container {
      display: flex;
      justify-content: center;
      align-items: center;
      .commodity-img {
        margin-right: 10px;
      }
    }
    .btns {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .delete-btn {
        cursor: pointer;
      }
      .remove-btn {
        margin-top: 20px;
        cursor: pointer;
      }
    }
  }
  .shopping-cart-operation {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-top: 20px;
    border: 1px solid #e4e4e4;
    // 吸底操作按钮
    &.fixed {
      box-sizing: border-box;
      width: 1020px;
      z-index: 99;
      position: fixed;
      padding: 6px;
      left: 50%;
      margin-left: -420px;
      bottom: 0;
      background: #f5f7fa;
    }
    // 隐藏吸底操作按钮
    &.hide-operation {
      display: none;
    }
    .left {
      display: flex;
      align-items: center;
      padding-left: 14px;
      .btn {
        margin-right: 10px;
        cursor: pointer;
      }
      .clear-btn {
        font-weight: 600;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .desc-amount {
        height: 32px;
        .amount {
          color: #df3445;
        }
      }
      .desc-total {
        height: 32px;
        margin-left: 10px;
        margin-right: 10px;
        .total {
          color: #df3445;
        }
        p {
          margin-bottom: 8px;
        }
      }
      .settle-btn {
        width: 100px;
        height: 52px;
        border: 0;
        border-radius: 0;
        color: #fff;
        background: rgba(223, 52, 69, 0.75);
        &:hover {
          background: rgba(223, 52, 69, 1);
        }
        &:active {
          border: none;
        }
      }
    }
  }
  .table-shopping-cart {
    .title-shopping-cart {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background: #f5f7fa;
      color: 606266;
      font-size: 12px;
      height: 40px;
      span {
        width: 150px;
        display: inline-block;
        text-align: center;
      }
      span:nth-of-type(1) {
        width: 240px;
      }
    }
    .content-shopping-cart {
      border: 1px solid #eee;
      border-top: none;
      .active {
        color: #bebebe;
      }
      .nothing {
        height: 48px;
        line-height: 48px;
        font-size: 12px;
        text-align: center;
      }
      .item-goods,
      .setMeal-children {
        height: 96px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .selet-shopping-cart {
        // width: 50px;
        padding: 0px 10px;
        box-sizing: border-box;
        .desc-container {
          border: 1px solid red;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 2px;
          .invalid-desc {
            font-size: 12px;
            color: #e83632;
          }
        }
      }
      .goods-shopping-cart {
        width: 240px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .img-desc-container {
          display: flex;
          align-items: center;
          .img-container {
            width: 56px;
            height: 56px;
            .commodity-img {
              width: 56px;
              height: 56px;
              cursor: pointer;
            }
          }
          .commodity-desc {
            flex: 1;
            height: 40px;
            line-height: 20px;
            font-size: 12px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          .commodity-desc:hover {
            color: #df3445;
          }
          .buyLimit {
            color: #df3445;
          }
        }
        .img-container {
          display: flex;
          justify-content: center;
          align-items: center;
          .commodity-img {
            margin-right: 10px;
          }
        }
      }
      .specs-shopping-cart,
      .unitPrice-shopping-cart,
      .nums-shopping-cart,
      .subtotal-shopping-cart,
      .operation-shopping-cart {
        width: 148px;
        font-size: 12px;
        text-align: center;
      }
      .btns {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .delete-btn {
          cursor: pointer;
        }
        .remove-btn {
          margin-top: 20px;
          cursor: pointer;
        }
      }
      .setMeal-content {
        .setMeal-top {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 48px;
          font-size: 12px;
          
          .desc-container {
            .invalid-desc {
              width: 24px;
            }
          }
          .setMeal-tags {
            width: 40px;
            height: 20px;
            line-height: 20px;
            margin-top: 2px;
            text-align: center;
            background: #DF3445;
            border-radius: 2px;
            color: #fff;
            font-weight: 400;
            font-size: 12px;
            margin-right: 10px;
          }
          .setMeal-title {
            width: 176px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .setMeal-children {
          border-top: 1px solid #eee;
          .goods-shopping-cart {
            padding-left: 50px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
#shoppingCart {
  .el-radio-group {
    font-size: 14px;
    .el-radio-button {
      border: none;
      .el-radio-button__inner {
        border: none;
        padding-left: 0;
        padding-bottom: 0;
        color: #919398;
        background: #fff;
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        box-shadow: none;
        color: #df3445;
      }
    }
  }
  .el-table {
    .el-table__header-wrapper {
      .el-table__header {
        .has-gutter {
          tr {
            th {
              color: #606266;
              background: #f5f7fa;
            }
          }
        }
      }
    }
  }
  .el-select {
    min-width: 120px;
    max-width: 120px;
    margin-right: 20px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
      background: rgba(234, 238, 245, 0.2);
      border-radius: 4px;
      border: 1px solid rgba(234, 238, 245, 1);
      padding: 0 20px 0 8px;
      font-size: 14px;
      font-family: "PingFangSC-Regular";
      color: rgba(96, 98, 102, 1);
      letter-spacing: 1px;
      padding-left: 15px;
    }
    .el-input__suffix {
      height: 40px;
      top: -3px;
      right: 0px;
    }
    .is-focus {
      .el-input__inner {
        border: 1px solid rgba(61, 116, 242, 1);
      }
    }
  }
  .el-input-number {
    width: 80px;
    height: 24px;
    border: none;
    .el-input-number__decrease {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 16px;
      height: 24px;
    }
    .el-input-number__increase {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 16px;
      height: 24px;
    }
    .el-input {
      width: 80px;
      height: 24px;
      line-height: 24px;
      border: none;
      .el-input__inner {
        display: block;
        width: 80px;
        height: 24px;
        line-height: 24px;
        padding-left: 0;
        padding-right: 0;
        outline: none;
        border: none;
      }
    }
  }
}
</style>
